import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake } from "caseparser";

export const lessonsApi = api
  .enhanceEndpoints({ addTagTypes: ["bonds"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      bonds: builder.query({
        query: ({ branchId }: any) => ({
          url: `branchs/${branchId}/bonds`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response.data,
        providesTags: ["bonds"],
      }),
      createBond: builder.mutation({
        query: ({
          branchId,
          name,
          description,
          price,
          session,
          maxSession,
          name_group_bond,
          groupBondId,
          checkedBonos,
          daysCaducity,
          currency,
          has_access_general,
        }: any) => ({
          url: `branchs/${branchId}/bonds`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            description,
            name_group_bond: name_group_bond || "",
            groupbond_id: name_group_bond ? null : groupBondId || null,
            price: price,
            currency,
            branch_id: branchId,
            has_access_general,
            session: session,
            repeated_bonus: checkedBonos,
            max_session: maxSession,
            days: daysCaducity,
          }),
        }),
        invalidatesTags: ["bonds"],
      }),
      updateBond: builder.mutation({
        query: (params: any) => {
          return {
            url: `branchs/${params.branchId}/bonds/${params.id}`,
            method: RequestMethod.PUT,
            body: camelToSnake({
              name: params.name,
              color: params.color,
              description: params.description,
              price: params.price,
              currency: params.currency,
              branchId: params.branchId,
              groupbondId: params.groupBondId,
              session: params.session,
              daysCaducity: params.daysCaducity,
              maxSession: params.maxSession,
              name_group_bond: params.name_group_bond,
              groupBond: params.groupBond,
            }),
          };
        },
        invalidatesTags: ["bonds"],
      }),
      deleteBond: builder.mutation({
        query: ({ branchId, id }: any) => ({
          url: `branchs/${branchId}/bonds/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["bonds"],
      }),
      assignedBonds: builder.query({
        query: ({ branchId, userId }: any) => ({
          url: `branchs/${branchId}/bonds/getBondUserById`,
          method: RequestMethod.POST,
          body: {
            user_id: userId,
          },
        }),
        transformResponse: (response: any) => response.data,
        providesTags: ["bonds"],
      }),
      activateDeactivateBond: builder.mutation({
        query: ({ branchId, bondId }: any) => {
          console.log("api bondId", branchId, bondId);

          return {
            url: `/branchs/${branchId}/bonds/${bondId}`,
            method: RequestMethod.DELETE,
          };
        },
        invalidatesTags: ["bonds"],
      }),
    }),
  });

export const {
  useBondsQuery,
  useCreateBondMutation,
  useUpdateBondMutation,
  useDeleteBondMutation,
  useAssignedBondsQuery,
  useActivateDeactivateBondMutation,
} = lessonsApi;
